import { Clickable, Col, Icon, Text } from 'components';
import { currencies } from 'lib';
import { memo, useState } from 'react';
import { TableComponents } from 'screens/Admin/components';
import { Menu } from './';

const numberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
const ShoutoutFromAthleteListItem = memo(({ item, onClick, dataId }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const isSelected = dataId === item._id,
    { name, pricing } = item;

  function currencySymbol(currency) {
    return currencies.find((x) => x.value.toLowerCase() === currency)?.symbol;
  }

  const serviceFee = () => {
    const amount = numberFormatter.format(pricing[0].amount * pricing[0].serviceFeePct * 0.01);
    return `${currencySymbol(pricing[0].currency)}${amount} (${pricing[0].serviceFeePct}%)`;
  };

  return (
    <TableComponents.Tr>
      <TableComponents.Td isSelected={isSelected} first>
        <Text wid="250px">{name}</Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex marg="0 0 0 -10px">
          <Text
            right
            wid="120px"
          >{`${currencySymbol(pricing[0].currency)}${numberFormatter.format(pricing[0].amount)}`}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text
            right
            wid="120px"
          >{`${currencySymbol(pricing[1]?.currency)}${numberFormatter.format(pricing[1]?.amount)}`}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text
            right
            wid="120px"
          >{`${currencySymbol(pricing[2]?.currency)}${numberFormatter.format(pricing[2]?.amount)}`}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text
            right
            wid="120px"
          >{`${currencySymbol(pricing[3]?.currency)}${numberFormatter.format(pricing[3]?.amount)}`}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex marg="0 0 0 -10px">
          <Text
            right
            wid="120px"
          >{`${currencySymbol(pricing[0].currency)}${numberFormatter.format(pricing[0].athleteFee)}`}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text center wid="130px">
            {serviceFee()}
          </Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col float="right" noFlex>
          <Clickable
            onClick={() => {
              setMenuVisible(!menuVisible);
            }}
          >
            <Icon pad="0 24px 0 0" type="menu" dimensions={12} />
          </Clickable>
          <Menu
            isTier1={item.default}
            dataId={item._id}
            visible={menuVisible}
            onClick={onClick}
            close={() => {
              setMenuVisible(false);
            }}
          ></Menu>
        </Col>
      </TableComponents.Td>
    </TableComponents.Tr>
  );
});

export default ShoutoutFromAthleteListItem;
